const VEHICLE = "VEHICLE";
const ASSET = "ASSET";
const KEYFOB = "KEYFOB";

export const DEVICE_TYPES = {
  VEHICLE,
  ASSET,
  KEYFOB,
};

export const VEHICLE_STATUS = {
  WARNING: "Warning",
  READY: "Ready",
};
